import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { disconnectUserWithLesson } from "api/services/user-service";

export const useDisconnectUserWithLesson = () => {
    const { callAPI, loading } = useWorkspaceApiCall(disconnectUserWithLesson, '', 'disconnectUserWithLesson.error');    

    return { disconnectUserWithLesson: callAPI, disconnectingWithLesson: loading };
}